/* Bundle grid: filters, ordering and Surprise me.

   HOW IT CONNECTS
   This does not touch the DOM of the grid. It supplies SF.bundleView — a
   function the builder calls with the pool, returning the frames to show,
   filtered and sorted. The builder then renders one page of them.

   That matters. The earlier version let the builder render all 400+ frames
   and then reordered and hid them afterwards. Every pick rebuilt four
   hundred cards and then moved them again, and while the browser was busy
   the next tap did nothing — the page felt frozen and unclickable. Doing
   the work on the array instead of the DOM removes that entirely.

   WHERE THE FILTER DATA COMES FROM
   A bundle card is a product, but every filter is a property of the FAMILY
   it belongs to. Rather than duplicate shape, material and colour into
   every page, this fetches the All frames grid once in the background and
   reads the attributes already rendered there. Product ids are the join,
   and the pool carries the product id alongside the variant id.

   NO PRICE FILTER: every frame in a tier costs the same.

   ---- ORDER IS BY FAMILY, NOT BY PRODUCT ----
   The pool arrives in the collection's own best-selling order, which is a
   PRODUCT order: every colourway is its own product, so the four Bavlis sit
   wherever their individual sales put them, and a shopper scrolling the
   grid met the same frame in four different places, pages apart, with no
   way to see the family as a set.

   Frames are therefore grouped by family, and the families are kept in
   best-selling order of their strongest member — the position of the
   highest-placed colourway in the pool. A family that sells well through
   one colour still rises; the other three come with it instead of being
   scattered behind two hundred other frames. Within a family the pool's own
   order is kept, so the best-selling colour leads.

   FAMILY MEMBERSHIP COMES FROM sf-data, not from the /collections fetch.
   sf-data is rendered on every page and lists every family's products with
   their product ids, including families marked hidden that never appear in
   the listing grid. The /collections fetch below is still used, but only
   for the filter attributes — if it fails, filtering degrades and the
   grouping is untouched.

   A product with no family in sf-data forms a group of its own and keeps
   its pool position, so nothing can be dropped or merged by this.

   SURPRISE ME SHUFFLES FAMILIES, NOT FRAMES. Randomising individual
   products would put the colourways straight back where they started. One
   random value is kept per family, so picking something never reshuffles
   the grid under you. */
(function(){
"use strict";
var CATS=["Sunglasses","Optical","Blue Light","Kids","Limited drops"];
var SHAPES=["Square","Round","Cat-eye","Pilot","Rectangle","Oval","Hexagon"];
var MATERIALS=["Acetate","Metal","Titanium","Polycarbonate","Carbon fibre","Acetate and metal","Wood"];
var TECHS=["Full rim","Half rim","Rimless"];
var FCOL=[["Black","#1c1c1c"],["Brown","#6b4a30"],["Tortoise","#8a5a2b"],["Blue","#3a5a7d"],["Green","#4c6b4f"],
["Grey","#8b8f92"],["Silver","#c9ccce"],["Gold","#b39a63"],["Red","#9c3b32"],["Pink","#e59ab4"],["Yellow","#e3c74a"],["Clear","#dfe3e4"]];
var LCOL=[["Black","#1c1c1c"],["Brown","#6b4a30"],["Green","#3f5c46"],["Blue","#3a5a7d"],["Grey","#8b8f92"],
["Yellow","#e3c74a"],["Pink","#e59ab4"],["Red","#9c3b32"],["Clear","#eef1f2"]];

var BY_PID=null, loading=null, open=false;
var f={types:[],shape:[],mat:[],tech:[],fcolour:[],lcolour:[]};
var shuffle=false, shuffleOrder={};

/* pid -> family handle, read once from the sf-data block. */
var FAM_OF=null;
function famIndex(){
  if(FAM_OF) return FAM_OF;
  FAM_OF={};
  var d={};
  try{ d=JSON.parse((document.getElementById('sf-data')||{}).textContent||'{}') }catch(e){}
  (d.families||[]).forEach(function(fam){
    (fam.products||[]).forEach(function(p){
      if(p && p.pid!=null && FAM_OF[String(p.pid)]===undefined) FAM_OF[String(p.pid)]=fam.handle;
    });
  });
  return FAM_OF;
}
/* An unknown product is its own family rather than a shared "unknown" one,
   so a gap in sf-data cannot glue unrelated frames together. */
function famKey(p){
  var h=famIndex()[String(p.pid)];
  return h ? 'f:'+h : 'p:'+p.pid;
}

function loadFamilies(){
  if(BY_PID) return Promise.resolve(BY_PID);
  if(loading) return loading;
  loading = fetch('/collections')
    .then(function(r){ return r.text() })
    .then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var map={};
      [].slice.call(doc.querySelectorAll('.fam-wrap')).forEach(function(w){
        var d=w.dataset;
        var shape=(d.shape||'').split('|').map(function(s){return s.trim()}).filter(Boolean);
        var types=(d.types||'').split('|').map(function(s){return s.trim()}).filter(Boolean);
        var tech=(d.tech||'').split('|').map(function(s){return s.trim()}).filter(Boolean);
        var mat=(d.material||'').trim(), rank=+d.rank||9999;
        var pids=(d.pids||'').split(','), fcol=(d.fcolour||'').split('|'), lens=(d.lens||'').split('|');
        pids.forEach(function(pid,i){
          pid=(pid||'').trim(); if(!pid) return;
          map[pid]={ shape:shape, types:types, tech:tech, mat:mat, rank:rank,
            fcolour:(fcol[i]||'').split('+').map(function(s){return s.trim()}).filter(Boolean),
            lens:(lens[i]||'').trim() };
        });
      });
      BY_PID=map;
      if(window.SF && typeof SF.renderBundles==='function') SF.renderBundles();
      return map;
    })
    .catch(function(){ BY_PID={}; return BY_PID });
  return loading;
}
function count(){ return f.types.length+f.shape.length+f.mat.length+f.tech.length+f.fcolour.length+f.lcolour.length }
function passes(info){
  if(!info) return count()===0;
  if(f.types.length && !f.types.some(function(t){return info.types.indexOf(t)>-1})) return false;
  if(f.shape.length && !f.shape.some(function(s){return info.shape.indexOf(s)>-1})) return false;
  if(f.mat.length && f.mat.indexOf(info.mat)<0) return false;
  if(f.tech.length && !f.tech.some(function(t){return info.tech.indexOf(t)>-1})) return false;
  if(f.fcolour.length && !f.fcolour.some(function(c){return info.fcolour.indexOf(c)>-1})) return false;
  if(f.lcolour.length && f.lcolour.indexOf(info.lens)<0) return false;
  return true;
}
function rnd(key){
  if(shuffleOrder[key]===undefined) shuffleOrder[key]=Math.random();
  return shuffleOrder[key];
}

/* The builder calls this with the pool and renders a page of what comes
   back. The pool's own index IS the best-selling rank, so it is captured
   before filtering and used both for the family order and for the order
   inside each family. */
window.__bundleView=function(pool){
  var map=BY_PID, pos={}, i;
  for(i=0;i<pool.length;i++) if(pos[pool[i].id]===undefined) pos[pool[i].id]=i;

  var kept=pool.filter(function(p){
    return passes(map ? map[String(p.pid)] : null);
  });

  var groups={}, order=[];
  kept.forEach(function(p){
    var k=famKey(p), g=groups[k];
    if(!g){ g=groups[k]={key:k, rank:pos[p.id], items:[]}; order.push(g) }
    else if(pos[p.id]<g.rank) g.rank=pos[p.id];
    g.items.push(p);
  });

  order.sort(shuffle
    ? function(a,b){ return rnd(a.key)-rnd(b.key) }
    : function(a,b){ return a.rank-b.rank });

  var out=[];
  order.forEach(function(g){
    g.items.sort(function(a,b){ return pos[a.id]-pos[b.id] });
    out=out.concat(g.items);
  });
  return out;
};

/* HOW FAR DOWN THE PAGE IS ACTUALLY VISIBLE.
   Two sticky elements stack at the top here — the site header and this
   filter bar — so the first usable pixel is below both. Measured, not
   assumed: the header collapses at different widths and the bar grows when
   filters are active, so any fixed number would be wrong somewhere. */
function stickyOffset(){
  var total=0;
  ['header.hdr','#bfBar'].forEach(function(sel){
    var el=document.querySelector(sel);
    if(!el) return;
    var pos=getComputedStyle(el).position;
    if(pos!=='sticky' && pos!=='fixed') return;
    total += el.getBoundingClientRect().height||0;
  });
  return total;
}

/* scrollIntoView({block:'start'}) aligns the grid with the TOP OF THE
   VIEWPORT, which is behind those bars — that is why the first row of
   frames appeared cut in half after every shuffle. Scrolling by hand to the
   grid's position minus the bars puts the row where it belongs. */
function scrollToGrid(){
  var g=document.getElementById('bGrid');
  if(!g) return;
  var y=g.getBoundingClientRect().top + window.scrollY - stickyOffset() - 12;
  window.scrollTo({ top: Math.max(0,y), behavior:'smooth' });
}

function paintMode(){
  var a=document.getElementById('bfBest'), b=document.getElementById('bfShuffle');
  if(a) a.setAttribute('aria-pressed', String(!shuffle));
  if(b){
    b.setAttribute('aria-pressed', String(shuffle));
    b.textContent = shuffle ? 'Shuffle again' : 'Surprise me';
  }
  var n=document.getElementById('bfN');
  if(n) n.textContent = count()? ' ('+count()+')' : '';
}
function redraw(){ if(window.SF && SF.renderBundles) SF.renderBundles(); paintMode() }

function chip(k,v){ return '<button class="chip" aria-pressed="'+(f[k].indexOf(v)>-1)+'" data-k="'+k+'" data-v="'+v+'">'+v+'</button>' }
function swatchRow(k,list){
  return list.map(function(c){
    return '<button aria-pressed="'+(f[k].indexOf(c[0])>-1)+'" data-k="'+k+'" data-v="'+c[0]+'"><i style="background:'+c[1]+'"></i>'+c[0]+'</button>';
  }).join('');
}
function panelHTML(){
  return '<div class="fgroup"><h4>Category</h4><div class="fopts">'+CATS.map(function(v){return chip('types',v)}).join('')+'</div></div>'+
  '<div class="fgroup"><h4>Shape</h4><div class="fopts">'+SHAPES.map(function(v){return chip('shape',v)}).join('')+'</div></div>'+
  '<div class="fgroup"><h4>Frame colour</h4><div class="cols">'+swatchRow('fcolour',FCOL)+'</div></div>'+
  '<div class="fgroup"><h4>Lens colour</h4><div class="cols">'+swatchRow('lcolour',LCOL)+'</div></div>'+
  '<div class="fgroup"><h4>Frame material</h4><div class="fopts">'+MATERIALS.map(function(v){return chip('mat',v)}).join('')+'</div></div>'+
  '<div class="fgroup"><h4>Rim style</h4><div class="fopts">'+TECHS.map(function(v){return chip('tech',v)}).join('')+'</div></div>'+
  '<div class="fgroup"><button class="btn out sm" id="bfClear">Clear filters</button></div>';
}

function build(){
  var line=document.getElementById('bLine'), grid=document.getElementById('bGrid');
  if(!line || !grid || document.getElementById('bfBar')) return;

  var css=document.createElement('style');
  css.textContent=
    '.bfseg{display:inline-flex;border:1px solid var(--line);border-radius:999px;overflow:hidden}'+
    '.bfseg button{appearance:none;background:#fff;border:0;padding:9px 16px;font:inherit;font-size:11px;'+
      'letter-spacing:.08em;text-transform:uppercase;color:var(--mute);cursor:pointer;white-space:nowrap}'+
    '.bfseg button+button{border-left:1px solid var(--line)}'+
    '.bfseg button[aria-pressed="true"]{background:#141a19;color:#fff}'+
    '.bfseg button:hover{color:var(--ink)}'+
    '.bfseg button[aria-pressed="true"]:hover{color:#fff}';
  document.head.appendChild(css);

  var bar=document.createElement('div');
  bar.id='bfBar'; bar.className='fbar';
  bar.innerHTML='<div class="in">'+
    '<button class="f" id="bfToggle"><svg class="ic" viewBox="0 0 24 24"><path d="M4 6h16M7 12h10M10 18h4"/></svg>Filters<span id="bfN"></span></button>'+
    '<span class="uc" style="font-size:10.5px;color:var(--mute)" id="bfCount"></span>'+
    '<span class="bfseg" role="group" aria-label="Order">'+
      '<button id="bfBest" aria-pressed="true">Best selling</button>'+
      '<button id="bfShuffle" aria-pressed="false">Surprise me</button>'+
    '</span></div>';
  var panel=document.createElement('div');
  panel.id='bfPanel';
  panel.style.cssText='display:none;padding:6px 20px 18px;max-width:1400px;margin:0 auto';
  line.parentNode.insertBefore(bar, line);
  line.parentNode.insertBefore(panel, line);

  var moreWrap=document.createElement('div');
  moreWrap.style.cssText='text-align:center;padding:22px 20px 4px';
  moreWrap.innerHTML='<button class="btn out sm" id="bfMore" style="display:none">Show more</button>';
  grid.parentNode.insertBefore(moreWrap, grid.nextSibling);

  document.getElementById('bfToggle').addEventListener('click', function(){
    open=!open;
    if(open && !panel.innerHTML) panel.innerHTML=panelHTML();
    panel.style.display = open ? '' : 'none';
  });
  document.getElementById('bfBest').addEventListener('click', function(){
    if(!shuffle) return;
    shuffle=false; redraw();
  });
  document.getElementById('bfShuffle').addEventListener('click', function(){
    shuffle=true; shuffleOrder={}; redraw();
    /* After the grid has been rebuilt, not before — and clear of the bars. */
    requestAnimationFrame(function(){ requestAnimationFrame(scrollToGrid) });
  });
  document.getElementById('bfMore').addEventListener('click', function(){
    if(window.SF && SF.showMoreBundles) SF.showMoreBundles();
  });
  panel.addEventListener('click', function(e){
    var b=e.target.closest ? e.target.closest('button') : null;
    if(!b) return;
    if(b.id==='bfClear'){ f={types:[],shape:[],mat:[],tech:[],fcolour:[],lcolour:[]}; panel.innerHTML=panelHTML(); redraw(); return }
    var k=b.getAttribute('data-k'), v=b.getAttribute('data-v');
    if(!k) return;
    var i=f[k].indexOf(v);
    if(i>-1) f[k].splice(i,1); else f[k].push(v);
    panel.innerHTML=panelHTML();
    redraw();
  });
  paintMode();
}

document.addEventListener('DOMContentLoaded', function(){
  if(!document.getElementById('bGrid')) return;
  if(window.SF){ SF.bundleView=window.__bundleView; SF.bundleReset=function(){}; }
  build();
  loadFamilies();
});
})();